// extracted by mini-css-extract-plugin
module.exports = {"styledButton":"s4rX5O20"};